export type PhoneCountry = {
  code: string
  name: string
  dial: string
}

export const phoneCountries: PhoneCountry[] = [
  { code: 'RW', name: 'Rwanda', dial: '+250' },
  { code: 'CD', name: 'DR Congo', dial: '+243' },
  { code: 'UG', name: 'Uganda', dial: '+256' },
  { code: 'TZ', name: 'Tanzania', dial: '+255' },
  { code: 'KE', name: 'Kenya', dial: '+254' },
  { code: 'BI', name: 'Burundi', dial: '+257' },
  { code: 'ZM', name: 'Zambia', dial: '+260' },
  { code: 'MG', name: 'Madagascar', dial: '+261' },
]
